module.exports = __webpack_public_path__ + "img/specialeffects-2_jp.d19f130.jpg";